import LegalLayout from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "The service",
    body: "NUC Service provides on-demand and contracted maintenance for residential and commercial properties: electrical, plumbing, HVAC and cooling, appliance repair, deep cleaning and annual maintenance. By booking a job or creating an account you accept these terms.",
  },
  {
    heading: "Bookings & payment",
    body: "Quotes are confirmed before work begins and do not change without your approval. Emergency call-outs carry a disclosed call-out fee. Payment is due on completion unless a maintenance contract states otherwise.",
  },
  {
    heading: "Warranty",
    body: "Every completed repair carries a 90-day workmanship warranty. If the same fault returns within that window, the revisit and the labour are free. Consumables and damage caused by third parties are excluded.",
  },
  {
    heading: "Liability",
    body: "Our crews are insured and certified. Liability is limited to the value of the job in question except where law requires otherwise. We are not responsible for pre-existing faults unrelated to the work performed.",
  },
  {
    heading: "Acceptable use",
    body: "Accounts are personal and non-transferable. You agree to provide accurate booking information and a safe working environment for our technicians. We may refuse service where a site is unsafe.",
  },
  {
    heading: "Changes & contact",
    body: "We may update these terms; the current version is always on this page with its revision date. Questions go to hello@nucservice.com or +1 (800) 555-0182.",
  },
];

export default function Terms() {
  return (
    <LegalLayout
      kicker="Legal — 02"
      title="Terms & Conditions"
      updated="June 2026"
      sections={SECTIONS}
      testId="terms-page"
    />
  );
}
